export const countryCrmCodeToIso: { [key: string]: string } = {
  "e5034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AF",
  "e6034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AL",
  "e7034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AQ",
  "e8034b17-0e3a-dd11-9d3d-001e0bcaa33c": "DZ",
  "e9034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AS",
  "ea034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AD",
  "eb034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AO",
  "ec034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AG",
  "ed034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AZ",
  "ee034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AR",
  "ef034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AU",
  "f0034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AT",
  "f1034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BS",
  "f2034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BH",
  "f3034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BD",
  "f4034b17-0e3a-dd11-9d3d-001e0bcaa33c": "AM",
  "f5034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BB",
  "f6034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BE",
  "f7034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BM",
  "f8034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BT",
  "f9034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BO",
  "fa034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BA",
  "fb034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BW",
  "fc034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BV",
  "fd034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BR",
  "fe034b17-0e3a-dd11-9d3d-001e0bcaa33c": "BZ",
  "ff034b17-0e3a-dd11-9d3d-001e0bcaa33c": "IO",
  "00044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SB",
  "01044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VG",
  "02044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BN",
  "03044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BG",
  "04044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MM",
  "05044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BI",
  "06044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BY",
  "07044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KH",
  "08044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CM",
  "09044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CA",
  "0a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CV",
  "0b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KY",
  "0c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CF",
  "0d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LK",
  "0e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TD",
  "0f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CL",
  "10044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CN",
  "11044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TW",
  "12044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CX",
  "13044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CC",
  "14044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CO",
  "15044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KM",
  "16044b17-0e3a-dd11-9d3d-001e0bcaa33c": "YT",
  "17044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CG",
  "18044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CD",
  "19044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CK",
  "1a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CR",
  "1b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HR",
  "1c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CU",
  "1d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CY",
  "1e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CZ",
  "1f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BJ",
  "20044b17-0e3a-dd11-9d3d-001e0bcaa33c": "DK",
  "21044b17-0e3a-dd11-9d3d-001e0bcaa33c": "DM",
  "22044b17-0e3a-dd11-9d3d-001e0bcaa33c": "DO",
  "23044b17-0e3a-dd11-9d3d-001e0bcaa33c": "EC",
  "24044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SV",
  "25044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GQ",
  "26044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ET",
  "27044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ER",
  "28044b17-0e3a-dd11-9d3d-001e0bcaa33c": "EE",
  "29044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FO",
  "2a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FK",
  "2b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GS",
  "2c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FJ",
  "2d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FI",
  "2e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FR",
  "2f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GF",
  "30044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PF",
  "31044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TF",
  "32044b17-0e3a-dd11-9d3d-001e0bcaa33c": "DJ",
  "33044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GA",
  "34044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GE",
  "35044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GM",
  "36044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PS",
  "37044b17-0e3a-dd11-9d3d-001e0bcaa33c": "DE",
  "38044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GH",
  "39044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GI",
  "3a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KI",
  "3b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GR",
  "3c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GL",
  "3d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GD",
  "3e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GP",
  "3f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GU",
  "40044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GT",
  "41044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GN",
  "42044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GY",
  "43044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HT",
  "44044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HM",
  "45044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VA",
  "46044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HN",
  "47044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HK",
  "48044b17-0e3a-dd11-9d3d-001e0bcaa33c": "HU",
  "49044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IS",
  "4a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IN",
  "4b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ID",
  "4c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IR",
  "4d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IQ",
  "4e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IE",
  "4f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IL",
  "50044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IT",
  "51044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CI",
  "52044b17-0e3a-dd11-9d3d-001e0bcaa33c": "JM",
  "53044b17-0e3a-dd11-9d3d-001e0bcaa33c": "JP",
  "54044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KZ",
  "55044b17-0e3a-dd11-9d3d-001e0bcaa33c": "JO",
  "56044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KE",
  "57044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KP",
  "58044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KR",
  "59044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KW",
  "5a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KG",
  "5b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LA",
  "5c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LB",
  "5d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LS",
  "5e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LV",
  "5f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LR",
  "60044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LY",
  "61044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LI",
  "62044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LT",
  "63044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LU",
  "64044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MO",
  "65044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MG",
  "66044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MW",
  "67044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MY",
  "68044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MV",
  "69044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ML",
  "6a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MT",
  "6b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MQ",
  "6c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MR",
  "6d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MU",
  "6e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MX",
  "6f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MC",
  "70044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MN",
  "71044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MD",
  "72044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ME",
  "73044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MS",
  "74044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MA",
  "75044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MZ",
  "76044b17-0e3a-dd11-9d3d-001e0bcaa33c": "OM",
  "77044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NA",
  "78044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NR",
  "79044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NP",
  "7a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NL",
  "7b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "AN",
  "7c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "AW",
  "7d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NC",
  "7e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VU",
  "7f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NZ",
  "80044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NI",
  "81044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NE",
  "82044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NG",
  "83044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NU",
  "84044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NF",
  "85044b17-0e3a-dd11-9d3d-001e0bcaa33c": "NO",
  "86044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MP",
  "87044b17-0e3a-dd11-9d3d-001e0bcaa33c": "UM",
  "88044b17-0e3a-dd11-9d3d-001e0bcaa33c": "FM",
  "89044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MH",
  "8a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PW",
  "8b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PK",
  "8c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PA",
  "8d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PG",
  "8e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PY",
  "8f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PE",
  "90044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PH",
  "91044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PN",
  "92044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PL",
  "93044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PT",
  "94044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GW",
  "95044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TL",
  "96044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PR",
  "97044b17-0e3a-dd11-9d3d-001e0bcaa33c": "QA",
  "98044b17-0e3a-dd11-9d3d-001e0bcaa33c": "RE",
  "99044b17-0e3a-dd11-9d3d-001e0bcaa33c": "RO",
  "9a044b17-0e3a-dd11-9d3d-001e0bcaa33c": "RU",
  "9b044b17-0e3a-dd11-9d3d-001e0bcaa33c": "RW",
  "9c044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SH",
  "9d044b17-0e3a-dd11-9d3d-001e0bcaa33c": "KN",
  "9e044b17-0e3a-dd11-9d3d-001e0bcaa33c": "AI",
  "9f044b17-0e3a-dd11-9d3d-001e0bcaa33c": "LC",
  "a0044b17-0e3a-dd11-9d3d-001e0bcaa33c": "PM",
  "a1044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VC",
  "a2044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SM",
  "a3044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ST",
  "a4044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SA",
  "a5044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SN",
  "a6044b17-0e3a-dd11-9d3d-001e0bcaa33c": "RS",
  "a7044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SC",
  "a8044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SL",
  "a9044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SG",
  "aa044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SK",
  "ab044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VN",
  "ac044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SI",
  "ad044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SO",
  "ae044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ZA",
  "af044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ZW",
  "b0044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ES",
  "b1044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SD",
  "b2044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SR",
  "b3044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SJ",
  "b4044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SZ",
  "b5044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SE",
  "b6044b17-0e3a-dd11-9d3d-001e0bcaa33c": "CH",
  "b7044b17-0e3a-dd11-9d3d-001e0bcaa33c": "SY",
  "b8044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TJ",
  "b9044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TH",
  "ba044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TG",
  "bb044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TK",
  "bc044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TO",
  "bd044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TT",
  "be044b17-0e3a-dd11-9d3d-001e0bcaa33c": "AE",
  "bf044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TN",
  "c0044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TR",
  "c1044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TM",
  "c2044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TC",
  "c3044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TV",
  "c4044b17-0e3a-dd11-9d3d-001e0bcaa33c": "UG",
  "c5044b17-0e3a-dd11-9d3d-001e0bcaa33c": "UA",
  "c6044b17-0e3a-dd11-9d3d-001e0bcaa33c": "MK",
  "c7044b17-0e3a-dd11-9d3d-001e0bcaa33c": "EG",
  "c8044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GB",
  "c9044b17-0e3a-dd11-9d3d-001e0bcaa33c": "GG",
  "ca044b17-0e3a-dd11-9d3d-001e0bcaa33c": "JE",
  "cb044b17-0e3a-dd11-9d3d-001e0bcaa33c": "IM",
  "cc044b17-0e3a-dd11-9d3d-001e0bcaa33c": "TZ",
  "cd044b17-0e3a-dd11-9d3d-001e0bcaa33c": "US",
  "ce044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VI",
  "cf044b17-0e3a-dd11-9d3d-001e0bcaa33c": "BF",
  "d0044b17-0e3a-dd11-9d3d-001e0bcaa33c": "UY",
  "d1044b17-0e3a-dd11-9d3d-001e0bcaa33c": "UZ",
  "d2044b17-0e3a-dd11-9d3d-001e0bcaa33c": "VE",
  "d3044b17-0e3a-dd11-9d3d-001e0bcaa33c": "WF",
  "d4044b17-0e3a-dd11-9d3d-001e0bcaa33c": "WS",
  "d5044b17-0e3a-dd11-9d3d-001e0bcaa33c": "YE",
  "d6044b17-0e3a-dd11-9d3d-001e0bcaa33c": "ZM",
};
